import React,{useState} from 'react'
import customerAddressServices from '../customerAddressServices';
import { Dialog, DialogContent, IconButton, Tooltip } from '@mui/material';
import CustomerAddressForm from './CustomerAddressForm';
import { useAppData } from '../../../../../context/AppDataContext';
import { Edit } from '@mui/icons-material';


function SelectCustomerAddress({customerDetails, callBack,caption,addressId}) {
    const [customerAddressList,setCustomerAddressList] = useState(null);
    const [loading,setLoadingStatus] = useState(false);

    const {getMasterLabel} = useAppData();

    const [dialogStatus, setDialogStatus] = useState(false);

    const getCustomerAddressList = () =>{
        setLoadingStatus(true);
        setDialogStatus(true);
        customerAddressServices.getByCustomerId(customerDetails.id).then(res=>{
            setCustomerAddressList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const selectShippingAddress = (customerAddressId) =>{
        setDialogStatus(false);
        callBack(customerAddressId);
    }
    
    
    return (
        <>
            {addressId ? 
                <Tooltip title="Update">
                    {/*<button type="button" className="btn btn-outline-primary" onClick={updateData} ><Edit/> Address</button> */}
                    <IconButton className="delete-icon me-2" onClick={getCustomerAddressList} style={{padding:"0px"}} >
                        <Edit/>
                    </IconButton>
                </Tooltip>
                :
                <button className='btn btn-primary me-2' onClick={getCustomerAddressList}>{caption ? caption :"Select Customer Address"}</button>
            }
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    {customerAddressList && customerAddressList.length == 0 &&
                        <div className='card mb-2'>
                            <div className='card-body text-center'>No Address found</div>
                        </div>
                    }
                    {customerAddressList?.map(customerAddress=>
                        <div className='card mb-2'>
                            <div className='card-body'>
                                <div className='float-end'>
                                    <CustomerAddressForm customerId={customerDetails.id} data={customerAddress} callback={getCustomerAddressList} />
                                </div>
                                <div>{customerAddress.contactPerson}</div>
                                <div>{customerAddress.address}</div>
                                <div>{customerAddress.city}, { getMasterLabel("indian-state",customerAddress.state) }, {customerAddress.zip}</div>
                                <div>{customerAddress.phone}, {customerAddress.email}</div>
                            </div>
                            {callBack &&
                                <div className='card-footer text-center'>
                                    <button className='btn btn-success' onClick={()=>selectShippingAddress(customerAddress.id)}>Select this address</button>
                                </div>
                            }
                        </div>
                    )}
                    <div className='card'>
                        <div className='card-body text-center'>
                            <CustomerAddressForm customerId={customerDetails.id} callback={getCustomerAddressList} />
                        </div>
                    </div>
                    
                </DialogContent>
            </Dialog>
        </>
    )
}

export default SelectCustomerAddress